import { Appear } from "@/components/appear";
import { IntegrationsPageList } from "@/pages/integrations/integrations-page-list";
import { IntegrationsPageHeader } from "@/pages/integrations/integrations-page-header";
import { IntegrationsPageSkeleton } from "@/pages/integrations/integrations-page-skeleton";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC, useState } from "react";
import { useTimeout } from "usehooks-ts";

type TProps = {};

export const IntegrationsPage: FC<TProps> = observer(() => {
  const { store } = useAppStore();
  const [ready, setReady] = useState(false);
  const chomeExtensionLoaded = !store.chromeExtension.isInstalled.isLoading;
  const emailsLoaded = !store.emailSenders.isLoading;
  const textMessagesLoaded = !store.textMessageSenders.isLoading;
  const allLoaded = chomeExtensionLoaded && emailsLoaded && textMessagesLoaded;

  useTimeout(() => {
    setReady(true);
  }, 100);

  return (
    <PageWrapper visible={ready}>
      <IntegrationsPageHeader />
      {allLoaded ? <IntegrationsPageList /> : <IntegrationsPageSkeleton />}
    </PageWrapper>
  );
});

const PageWrapper = styled(Appear)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});
